import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./navegation/loginPage";
import MainMenu from "./navegation/mainMenu";
import SalesMenu from "./navegation/salesMenu";
import SalesArticleMenu from "./navegation/salesArticleMenu";
import CashMovementsMenu from "./navegation/cashMovementsMenu";
import ArticlesStockMenu from "./navegation/articlesStockMenu";
import ClientsAccountsMenu from "./navegation/clientsAccountsMenu";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/menu" element={<MainMenu />} />         {/* menu principal */}
        <Route path="/ventas" element={<SalesMenu />} />{/* informe ventas */}
        <Route path="/ventas-por-articulo" element={<SalesArticleMenu />} />{/* informe ventas por articulo */}
        <Route path="/movimientos-de-caja" element={<CashMovementsMenu />} />{/* informe apertura/cierre cajas */}
        <Route path="/articulos-stock" element={<ArticlesStockMenu />} />{/* informe articulos/stock */}
        <Route path="/cuentas-corrientes" element={<ClientsAccountsMenu />} />{/* informe cuentas corrientes */}
      </Routes>
    </Router>
  );
};

export default App;

